require('../../../modules/es.array.filter');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').filter;